import script from "./InputFieldForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputFieldForm.vue?vue&type=script&lang=ts&setup=true"

import "./InputFieldForm.vue?vue&type=style&index=0&id=40fd62d6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40fd62d6"]])

export default __exports__